import { render } from "./DashboardContent.vue?vue&type=template&id=0b19639b&ts=true"
import script from "./DashboardContent.vue?vue&type=script&lang=ts"
export * from "./DashboardContent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__